export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["से स्ट्रिंग"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["तक"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अक्षर"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अमान्य मान"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["आवश्यक क्षेत्र"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["फ़ील्ड की जाँच करें"])}
}